import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton, Tooltip, useTheme } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

export default function CopyableText({ value, maxWidth = '200px', typographyProps = {} }) {
  const [copied, setCopied] = useState(false);
  const theme = useTheme();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
      <Tooltip title={value} arrow>
        <Typography
          variant="body2"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth,
            ...(typographyProps.sx || {})
          }}
          {...typographyProps}
        >
          {value}
        </Typography>
      </Tooltip>
      <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'}>
        <IconButton 
          onClick={handleCopy}
          size="small"
          sx={{
            p: 0.5,
            color: copied ? 'success.main' : 'text.secondary',
            '&:hover': {
              color: 'primary.main',
              backgroundColor: 'transparent',
            },
          }}
        >
          {copied ? 
            <CheckIcon fontSize="small" /> : 
            <ContentCopyIcon fontSize="small" />
          }
        </IconButton>
      </Tooltip>
    </Box>
  );
}

CopyableText.propTypes = {
  value: PropTypes.string.isRequired,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  typographyProps: PropTypes.object,
};
